import { render, staticRenderFns } from "./DashBoardFundsTransferView.vue?vue&type=template&id=572974aa&scoped=true&"
import script from "./DashBoardFundsTransferView.vue?vue&type=script&lang=js&"
export * from "./DashBoardFundsTransferView.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardFundsTransferView.vue?vue&type=style&index=0&id=572974aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572974aa",
  null
  
)

export default component.exports